<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on: tooltip, attrs }">
      <v-btn
        v-bind="{ ...attrs, ...$attrs }"
        v-on="{ ...tooltip, ...$listeners }"
        icon
        class="mx-1"
        @click="openSupportPage"
      >
        <v-icon>mdi-lifebuoy</v-icon>
      </v-btn>
    </template>
    <span> Ask for help </span>
  </v-tooltip>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  props: {},

  data: () => ({
    //
  }),

  methods: {
    async openSupportPage() {
      window.open('https://sharylist.freshdesk.com/', '_blank')
    },
    ...mapMutations(['toastSet']),
  },
}
</script>
